import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/site";
import Reveal from "./Reveal";
import { Bird, Spiral, Lightning } from "./Doodles";

export default function FAQ() {
  return (
    <section className="relative py-24 md:py-36 px-5 md:px-10 bg-[#FAFAF7] overflow-hidden" data-testid="faq">
      <Bird size={70} className="absolute top-14 right-[10%] wiggle hidden md:block" color="#A9CDE5" />
      <Spiral size={48} className="absolute bottom-20 left-[6%] hidden md:block" color="#F4C734" />
      <Lightning size={32} className="absolute top-1/3 left-[3%] wiggle hidden lg:block" />

      <div className="relative mx-auto max-w-[1100px] grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Reveal>
            <p className="eyebrow mb-4">FAQ</p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.025em]">
              Little eyes,<br /><span className="italic" style={{ color: "#DD2E20" }}>big questions.</span>
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-6 text-[#595955] text-base md:text-lg max-w-[34ch]">
              Need help picking a frame? WhatsApp us — Natasha or the team will walk you through it.
            </p>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem value={`item-${i}`} key={f.q} className="border-b border-[#2C2C2A]/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-lg md:text-2xl py-5 md:py-7 tracking-tight hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#595955] text-base md:text-lg leading-relaxed pb-6 max-w-[58ch]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
